/// <amd-module name="Feed/IvyPromote/Redux/IvyPromote/IvyPromoteReducers" />
import { IvyPromoteActions, IvyPromoteActionTypes } from "Feed/IvyPromote/Redux/IvyPromote/IvyPromoteActions";
import { IIvyPromoteState } from "Feed/IvyPromote/Redux/IvyPromote/IvyPromoteContracts";
import produce from "immer";

export const ivyPromoteReducer = produce((draft: IIvyPromoteState, action: IvyPromoteActions) => {
    switch (action.type) {
        case IvyPromoteActionTypes.StatusListLoaded:
            draft.statuses = action.payload.status;
            break;

        case IvyPromoteActionTypes.StatusLoaded:
            draft.currentStatus = action.payload.currentStatus;
            break;

        case IvyPromoteActionTypes.SaveStarted:
            draft.isSaving = true;
            delete draft.errorMessage;
            break;

        case IvyPromoteActionTypes.SaveCompleted:
            draft.isSaving = false;
            delete draft.errorMessage;
            break;

        case IvyPromoteActionTypes.ApiCallFailed:
            draft.isSaving = false;
            draft.errorMessage = action.payload.errorMessage;
            break;
    }
}, getDefaultIvyPromoteState());

export function getDefaultIvyPromoteState() {
    return {
        isSaving: false,
        statuses: [],
        currentStatus: ""
    };
}
